import React from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { colors } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {closeAlert } from 'actions'
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({
  message: {
    whiteSpace: 'pre-wrap',
    maxHeight: '90vh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  content: {
    padding: theme.spacing(0, 2),
    maxWidth: 720,
    margin: '0 auto'
  },
  contact: {
    margin: theme.spacing(3, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  yesButton: {
    marginRight: theme.spacing(2)
  }
}));

const ConfirmationDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, type, typeProps } = useSelector(state => state.alert);
  const {message, title, actionYes, actionNo, resolve, reject} = typeProps;

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      reject();
      return;
    }
    dispatch(closeAlert())
  };

  const handleYes = () => {
    resolve();
    handleClose();
  }

  const handleNo = () => {
    reject();
    handleClose();
  }

  const isOpen = type === 'confirmation' && open

  return (
    <Dialog
      TransitionComponent={Slide}
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      open={isOpen}
    >
      <div className={classes.header}>
        <Typography variant="h3">
          {title || 'Are you sure you want to perform this action?'}
        </Typography>
      </div>
      <Divider />
      <div className={classes.content}>
        <Typography
          align="center"
          className={classes.contact}
          variant="subtitle1"
        >
          {message}
        </Typography>
      </div>
      <div className={classes.actions}>
        <Button
          className={classes.yesButton}
          color='primary'
          onClick={handleYes}
          variant="contained"
        >
          {actionYes || 'Ok'}
        </Button>
        <Button
          onClick={handleNo}
        >
          {actionNo || 'Cancel'}
        </Button>
      </div>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  className: PropTypes.string
};

export default ConfirmationDialog;
